export function SET_CURRENT_LEVEL(state, level) {
  state.levelSelected = level;
}
